import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';


@NgModule({
  imports: [
    CommonModule, TableModule, ContextMenuModule, DialogModule, FormsModule, CalendarModule, MultiSelectModule, DropdownModule
  ],
  exports: [TableModule, ContextMenuModule, DialogModule, FormsModule, CalendarModule, MultiSelectModule, DropdownModule],
  declarations: []
})
export class PrimengModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/modules/primeng/primeng.module.ts